import { FeatureFlags, formatFeatureFlagsForTracking } from "shared";
import { mt } from "./tracking";

export type OnReadyPayload = {
  featureFlags: FeatureFlags;
  emailHash: string;
  isPolicyHolder?: boolean;
  hasOutstandingBalance?: boolean;
  hasHdc?: boolean;
  hasESignDocuments?: boolean;
};

let hasLoggedOnReady = false;

export const resetLogOnReady = (): void => {
  hasLoggedOnReady = false;
};

export const logOnReady = (payload: OnReadyPayload): void => {
  if (
    hasLoggedOnReady ||
    payload.isPolicyHolder === undefined ||
    payload.hasOutstandingBalance === undefined ||
    payload.hasHdc === undefined
  ) {
    return;
  }

  hasLoggedOnReady = true;
  const featureToggles = formatFeatureFlagsForTracking(payload.featureFlags);
  mt.trackView({
    _tag_name: "account_main_page",
    user_type: "direct",
    logged_in: true,
    mobile_app: false,
    test_experience: featureToggles,
    hashed_email: payload.emailHash,
    insurance_indicator: payload.isPolicyHolder,
    has_positive_bill_amount: payload.hasOutstandingBalance,
    hdc_membership: payload.hasHdc,
    has_message_displayed: payload.hasESignDocuments,
  });
};
